<template>
	<div class="nav-mobile-top">
		<a
			v-for="item in topNavItems"
			:key="item.link"
			:href="item.link"
			:target="mixinIsExternalLink(item.link) ? '_blank' : '_self'"
			:rel="mixinIsExternalLink(item.link) ? 'noopener' : ''"
			class="nav-mobile-top__item"
			:class="{'is-active': item.isActive}"
		>
			<span>{{ item.title }}</span>
			<V2Icon
				v-if="mixinIsExternalLink(item.link)"
				icon-name="launch"
				size="xxs"
			/>
		</a>
	</div>
</template>

<script>
import V2Icon from '@shared/components/Icon';

export default {
	name:       'NavMobileTop',
	components: { V2Icon },
	props:      {
		topNavItems: {
			type:    Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.nav-mobile-top {
	@include z-index(arena-sticky-mobile-top-nav);
	position: sticky;
	top: 48px;
	display: flex;
	flex-direction: row;
	width: 100%;
	color: var(--color-white);
	background-color: var(--color-grey-900);
	padding: 0 $sp3;
	overflow-x: auto;
	overflow-y: hidden;
	white-space: nowrap;
	-webkit-overflow-scrolling: touch;

	body.-t-light & { // stylelint-disable-line selector-max-type, selector-no-qualifying-type
		color: var(--color-black);
	}

	body.is-player-mode & { // stylelint-disable-line selector-max-type, selector-no-qualifying-type
		@include mobile-media-query {
			display: none;
		}
	}

	@include size(md-up) {
		display: none;
	}
}

.nav-mobile-top__item {
	position: relative;
	display: flex;
	gap: $sp2;
	justify-content: space-between;
	align-items: center;
	margin: 0 $sp3;
	padding: $sp4 0;
	font-size: 14px; // stylelint-disable-line property-disallowed-list, sh-waqar/declaration-use-variable
	font-weight: 500; // stylelint-disable-line
	cursor: pointer;
	flex-shrink: 0;

	&::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: $sp3;
		width: 100%;
		height: 1px;
		background-color: var(--color-cta, var(--color-hype-yellow));
		opacity: 0;
		transition: opacity $trans-time-fast;
	}

	&:hover,
	&:focus,
	&.is-active {
		&::after {
			opacity: 1;
		}
	}
}

</style>
